import {format} from "fecha";
import { format as formatDateFns, parse } from 'date-fns';
import ptbr from 'date-fns/locale/pt';

export const getFormattedDate = (date?: Date) => {
  return date ? format(new Date(date), 'DD/MM/YYYY') : '';
}

export const getFormattedDayMonthAndYear = (value) => {
  /* o formato será: "dd 'de' MMMM 'de' yyyy" -> 03 de janeiro de 2023 */
  const date = parse(value, "dd'-'MM'-'yyyy", new Date());

  const formattedDate = formatDateFns(date, "dd 'de' MMMM 'de' yyyy", {
      locale: ptbr
  });

  return formattedDate;
}

export const getFormattedDayMonthYearAndHour = (value) => {
/*o formato será: "dd 'de' MMMM 'de' yyyy às hh:mm" */

  const slicedDate = value.slice(0, 10);
  const time = value.slice(11, 16);

  const formattedDate = getFormattedDayMonthAndYear(slicedDate);

  const dateTime = `${formattedDate} às ${time}`

  return dateTime;
}

export const getFormattedMonthAndYear = (lastChangeDate) => {
  /* o formato será: MMMM/yyyy -> janeiro/2023 */
  const date = parse(lastChangeDate, "dd'-'MM'-'yyyy", new Date());
  const month = date.toLocaleString('default', { month: 'long' });
  const year = date.getFullYear();
  return `${month[0].toUpperCase()}${month.slice(1).toLowerCase()}/${year}`;
}